import React, {ReactNode, useState} from 'react';

interface SanityPageContextValue {
  pageId: string | null;
  setPageId: React.Dispatch<React.SetStateAction<string | null>>;
}

const SanityPageContext = React.createContext<
  SanityPageContextValue | undefined
>(undefined);

export const useSanityPageContext = () => {
  const sanityPageContext = React.useContext(SanityPageContext);
  if (sanityPageContext === undefined) {
    throw new Error('useSanityPageContext must be inside a SanityPageProvider');
  }
  return sanityPageContext;
};

type SanityPageProviderProps = {
  children: ReactNode;
};

export const SanityPageProvider: React.FC<SanityPageProviderProps> = ({
  children,
}) => {
  const [pageId, setPageId] = useState<string | null>(null);

  return (
    <SanityPageContext.Provider value={{pageId, setPageId}}>
      {children}
    </SanityPageContext.Provider>
  );
};
